// wi_6b5960f9-952c-48fc-ab25-68e9f9e5b2da: the reconstructed input overlay and velocity panel.
// rsparse movement_buttons() infers W/A/S/D from the move direction, and sets IN_MOVERIGHT
// (0x400) for a move to the player's LEFT so Restrat replays it. So 0x400 is drawn as A.
import { framePlayers, isDead } from './scene3d';

const KEY_BITS = {
  W: 0x8, A: 0x400, S: 0x10, D: 0x200,
};
const FIRE_TICKS = 8;

export function movementKeys(mask) {
  const keys = {};
  // eslint-disable-next-line no-bitwise
  Object.entries(KEY_BITS).forEach(([key, bit]) => { keys[key] = Boolean((mask || 0) & bit); });
  return keys;
}

// rsparse rounds velocity to whole units/s.
export function velocityReadout(player) {
  return {
    speed: Math.round(Math.hypot(player.velocityX || 0, player.velocityY || 0)),
    vertical: player.isAirborne ? Math.round(player.velocityZ || 0) : null,
  };
}

// False when no alive player has a non-zero mask in any frame (demo without usercmds).
export const hasMovementInput = (frames) => (frames ?? []).some((frame) => framePlayers(frame)
  .some((player) => !isDead(player) && player.toggleButtonMask));

export const isFiring = (weaponFires, steamID, tick) => (weaponFires ?? []).some((fire) => (
  fire.playerSteamID === steamID && tick >= fire.tick && tick < fire.tick + FIRE_TICKS
));
